import { Controller } from 'react-hook-form';

import { FormItem, NumberInput } from '@ingrid/luterkort-react';

import { ValidateSchema } from '../../create/validate';
import { DynamicPath, useCarrierContractFormContext } from '../../types';
import { useUISchema } from '../hooks';
import { Schema } from '../queries';
import { SchemaFormLabel } from './schema-form-label';
import { SchemaFormSubText } from './schema-form-sub-text';

interface Props {
  disabled?: boolean;
  schemaId: string;
  schema: Schema;
  path?: string;
}

export function SchemaFormNumber({ schema, schemaId, disabled, path = '' }: Props) {
  const { control } = useCarrierContractFormContext();
  const { defaultValue } = useUISchema({ schemaId, path });

  return (
    <FormItem.Root>
      <SchemaFormLabel schema={schema} path={path} schemaId={schemaId} />

      <Controller
        rules={ValidateSchema(path, schemaId, schema)}
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-explicit-any
        defaultValue={defaultValue as any}
        name={path as DynamicPath}
        control={control}
        render={({ field, fieldState }) => (
          <FormItem.Control invalid={fieldState.invalid}>
            <NumberInput
              {...field}
              onChange={event => field.onChange(event)}
              formatOptions={{ maximumFractionDigits: 8 }}
              value={field.value as number | undefined}
              invalid={fieldState.invalid}
              disabled={disabled}
            />
          </FormItem.Control>
        )}
      />

      <SchemaFormSubText schema={schema} path={path} />
    </FormItem.Root>
  );
}
